import React from 'react';
import DigestAlertsComponent from '@dataroom/email-alerts/ui/DigestAlerts';
import { ITimezone } from '@framework/timezone/vo/Timezone';
import { IDigestNotificationSettingsPayload } from '@dataroom/email-alerts/domain/vo/DigestEmailAlerts';
import styles from './digestAlerts.module.scss';

interface IProps<T = IDigestNotificationSettingsPayload> {
  initialValues: T,
  timezone: ITimezone,
  onChange: (v: T) => void,
  isFetching: boolean,
}

const DigestAlerts = ({ initialValues, timezone, onChange, isFetching }: IProps) => (
  <>
    <div className={ styles.title }>
      Digest Alerts
    </div>
    <div className={ styles.container }>
      <div className={ styles.alertsTitle }>
        Digest Alerts provide analytic reports directly by email.
      </div>
      <DigestAlertsComponent
        initialValues={ initialValues }
        timezone={ timezone }
        onChange={ onChange }
        isFetching={ isFetching }
      />
    </div>
  </>
);

export default DigestAlerts;
